import { Col, Grid, Row, Skeleton } from "@codat/orchard-ui";
import { usePageWidthViewContext } from "contexts/PageWidthViewContext";
import React from "react";

import styles from "./PageLoadingSkeleton.module.css";

export const PageLoadingSkeleton = () => {
  const { fullWidthView } = usePageWidthViewContext();

  return (
    <Grid
      className={styles.grid}
      data-testid="page-loading-skeleton"
      fullWidth={fullWidthView}
    >
      <Row>
        <Col size={12}>
          <Skeleton width="16rem" height="3rem" />
          <Skeleton width="12rem" height="1rem" className={styles.block} />
          <Skeleton width="100%" height="25rem" className={styles.block} />
        </Col>
      </Row>
    </Grid>
  );
};
